export default __webpack_public_path__ + "static/media/addPeople.aecfb2bb.svg";